import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card , Switch , InputNumber, Tag, TimePicker} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, EyeOutlined, DeleteOutlined,RadarChartOutlined } from '@ant-design/icons';
import { GEOFENCE_MANAGEMENT_LIST, GEOFENCE_MANAGEMENT_LIST_SUCCESS, GEOFENCE_MANAGEMENT_LIST_ERROR } from './constants';
import { GEOFENCE_MANAGEMENT_DETAILS, GEOFENCE_MANAGEMENT_DETAILS_SUCCESS, GEOFENCE_MANAGEMENT_DETAILS_ERROR } from './constants';
import { ADD_GEOFENCE_MANAGEMENT_DETAILS, ADD_GEOFENCE_MANAGEMENT_DETAILS_SUCCESS, ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR } from './constants';
import { UPDATE_GEOFENCE_MANAGEMENT, UPDATE_GEOFENCE_MANAGEMENT_SUCCESS, UPDATE_GEOFENCE_MANAGEMENT_ERROR } from './constants';
import { DELETE_GEOFENCE_MANAGEMENT, DELETE_GEOFENCE_MANAGEMENT_SUCCESS, DELETE_GEOFENCE_MANAGEMENT_ERROR } from './constants';

import geofencemanagementReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import {InfoOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const { Title } = Typography;

export default function GeofenceManagement() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {geofencemanagement : [], details: null, pending: false, error: false };
	const [data, dispatch] = useReducer(geofencemanagementReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showAddGeofenceManagementModal, setShowAddGeofenceManagementModal] = useState(false);
	const [showEditGeofenceManagementModal, setShowEditGeofenceManagementModal] = useState(false);
	const [showDeleteGeofenceManagementModal, setShowDeleteGeofenceManagementModal] = useState(false);
	useAuth();
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	

	

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const navigate = useNavigate();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	let switched = false;
	const columns = [

		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			
		},
		{
			title: langdata && langdata.FenceLimits ? langdata.FenceLimits : 'Fence Limits',
			dataIndex: 'limit',
			key: 'limit',
			
		},
		{
			title: langdata && langdata.AvgVelocity ? langdata.AvgVelocity : 'Avg Velocity (km/h)',
			dataIndex: 'averageSpeed',
			key: 'averageSpeed',
		},
		{
			title: langdata && langdata.StartTime ? langdata.StartTime : 'StartTime ',
			dataIndex: 'startTime',
			key: 'StartTime',
			
		},
		{
			title: langdata && langdata.EndTime ? langdata.EndTime : 'End Time',
			dataIndex: 'endTime',
			key: 'endTime',
			
		},
		{
			title: langdata && langdata.Notifications ? langdata.Notifications : 'Notifications',
			dataIndex: 'notification',
			key: 'notification',
			render:(_,notification) =>(
				<>
					{notification && 
				<Tag color={notification.notification === 'true' ? 'green' : 'red'} >
					{notification.notification === 'true' ? langdata && langdata.Enabled ? langdata.Enabled :'Enabled' : langdata && langdata.Disabled ? langdata.Disabled : 'Disabled'}
				</Tag> }
				</>
			)
			
		},

		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: () => (
				permission === 'superadmin' || permission === 'admin' ? (
					<Space size="middle">
						<a title={langdata && langdata.EditGeofenceManagement ? langdata.EditGeofenceManagement :'Edit Geofence Management  '} onClick={openEditGeofenceManagementModal}><EditOutlined/></a>
						<a title={langdata && langdata.DeleteGeofenceManagement ? langdata.DeleteGeofenceManagement :'Delete Geofence Management'} onClick={openDeleteGeofenceManagementModal}><DeleteOutlined /></a>
					</Space>
				) : (
					<Space size="middle">
						<a title={langdata && langdata.EditGeofenceManagement ? langdata.EditGeofenceManagement :'Edit Geofence Management  '} onClick={openEditGeofenceManagementModal}><EyeOutlined/></a>
					</Space>
				)
			)
		}
	];

	const openAddGeofenceManagementModal = () => {
		setShowAddGeofenceManagementModal(true);
	};

	const cloaseAddGeofenceManagementModal = () => {
		setShowAddGeofenceManagementModal(false);
	};

	const openEditGeofenceManagementModal = () => {
		setShowEditGeofenceManagementModal(true);
	};

	const closeEditGeofenceManagementModal = () => {
		setShowEditGeofenceManagementModal(false);
	};

	const openDeleteGeofenceManagementModal = () => {
		setShowDeleteGeofenceManagementModal(true);
	};

	const deleteGeofenceManagement = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_GEOFENCE_MANAGEMENT });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/geofencemanagement/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_GEOFENCE_MANAGEMENT_SUCCESS, payload: response});
					setShowDeleteGeofenceManagementModal(false);   
					loadGeofenceManagement();       
				} else {
					dispatch({type:DELETE_GEOFENCE_MANAGEMENT_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_GEOFENCE_MANAGEMENT_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeleteGeofenceManagementModal = () => {
		setShowDeleteGeofenceManagementModal(false);
	};

	useEffect(() => {
		if(featuresModule.geofenceManagementEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4009);
	}, []);

	useEffect(() => {
		dispatch( { type: GEOFENCE_MANAGEMENT_LIST });
      
		loadGeofenceManagement();
	}, []);
	

	const loadGeofenceManagement = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/geofencemanagement?&pipelineId=${pipelineId}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {

				if (response.status === 200) {
					dispatch({type:GEOFENCE_MANAGEMENT_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:GEOFENCE_MANAGEMENT_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadGeofenceManagementDetails = ((record) => {


      
		dispatch( { type: GEOFENCE_MANAGEMENT_DETAILS });
    
		if (!record) {
			dispatch({ type: GEOFENCE_MANAGEMENT_DETAILS_ERROR });
		} else {
			dispatch({ type: GEOFENCE_MANAGEMENT_DETAILS_SUCCESS, payload: record });

		}

	});

	const addGeofenceManagementFormik = useFormik({
		initialValues: {
			addGeofencemanagementName: '',
			addGeofencemanagementLimit: 0,
			startTime: '',
			endTime: '',

		},
		onSubmit: (values) => {
			const name = values.addGeofencemanagementName ? values.addGeofencemanagementName : '';
			const limit = values.addGeofencemanagementLimit ? parseInt(values.addGeofencemanagementLimit) : 0;
			const notification = values.addGeofencemanagementNotifications ? values.addGeofencemanagementNotifications :  switched ;
			const startTime = values.startTime; 
			const endTime = values.endTime; 
			const averageSpeed = values.averageSpeed;

			if (!name || name == null || name  === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}

			if (!limit || limit == null || limit  === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterFenceLimits ? langdata.PleaseEnterFenceLimits : 'Please enter Fence Limits' });
				return false;
			}
			if (!startTime || startTime == null || startTime  === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterStartTime ? langdata.PleaseEnterStartTime : 'Please enter start time' });
				return false;
			}
			if (!endTime || endTime == null || endTime  === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterEndTIme ? langdata.PleaseEnterEndTIme : 'Please enter end time' });
				return false;
			}


			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/geofencemanagement`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					limit : limit,
					notification : notification , 
					pipelineId : parseInt(pipelineId),
					startTime  : startTime,
					endTime : endTime,
					averageSpeed : averageSpeed

				}
			};

			dispatch( { type: ADD_GEOFENCE_MANAGEMENT_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_GEOFENCE_MANAGEMENT_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.GeofenceManagementAddedSuccessfully ? langdata.GeofenceManagementAddedSuccessfully : 'Geofence management added successfully' });
						setShowAddGeofenceManagementModal(false);
						addGeofenceManagementFormik.resetForm();
						loadGeofenceManagement();
					} else {
						dispatch({type: ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToSaveGeofenceManagement ? langdata.UnableToSaveGeofenceManagement : 'Unable to save geofence management' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});
	
	const updateGeofenceManagementFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			updateGeofencemanagementName: data.details ? data.details.name : '' ,
			updateGeofencemanagementLimit: data.details ? data.details.limit : 0,
			updateGeofencemanagementNotification : data.details ? data.details.booleannotification : 0,
			updateStartTime : data?.details?.utcstart === null ? '' : data?.details?.utcstart ,
			updateEndTime : data?.details?.utcend === null ? '' : data?.details?.utcend ,
			updateAverageSpeed : data?.details?.averageSpeed === null ? '' : data?.details?.averageSpeed

			
		},
		onSubmit: (values) => {
			const id = data.details.id;
			const name = values.updateGeofencemanagementName ? values.updateGeofencemanagementName : '';
			const limit = values.updateGeofencemanagementLimit ? values.updateGeofencemanagementLimit : 0;
			const notification  = values.updateGeofencemanagementNotification ;
			const startTime = values.updateStartTime;
			const endTime = values.updateEndTime;
			const averageSpeed = values.updateAverageSpeed;


			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/geofencemanagement/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					limit : limit,
					notification : notification,
					pipelineId : parseInt(pipelineId),
					startTime : startTime,
					endTime : endTime,
					averageSpeed : averageSpeed
				}
			};

			dispatch( { type: UPDATE_GEOFENCE_MANAGEMENT });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_GEOFENCE_MANAGEMENT_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.GeofenceManagementUpdatedSuccessfully ? langdata.GeofenceManagementUpdatedSuccessfully : 'Geofence management updated successfully' });
						setShowEditGeofenceManagementModal(false);
						updateGeofenceManagementFormik.resetForm();
						loadGeofenceManagement();
					} else {
						dispatch({type: UPDATE_GEOFENCE_MANAGEMENT_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToUpdateGeofenceManagement ? langdata.UnableToUpdateGeofenceManagement : 'Unable to update geofence management' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_GEOFENCE_MANAGEMENT_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.GeofenceManagementInfoContent ? langdata.GeofenceManagementInfoContent :  'This module is used to manage the boundaries and active time settings of pipelines for STS app users.'}</p>
		</Card>
	);

	return (
		permission==='superadmin' || permission === 'admin' ? 

			<>
				<Content>
					<Row style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
						
					}}
					>

						<Col span={12}>
							<Row>
								<Space>
									<RadarChartOutlined  style={{fontSize:'30px'}}/>
									{/* </Col> */}
								</Space>
								<Space>&nbsp;&nbsp;</Space>
								<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.GeofenceManagement ? langdata.GeofenceManagement:'GeoFence  Management'  }</Title>
							</Row>
						</Col>
					
						<Col span={12}>
							<Row justify="end">
								<Col>
									<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
										<Space>
											{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={openAddGeofenceManagementModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
										</Space>
									</Tooltip>
									<Space>&nbsp;&nbsp;</Space>
									<Tooltip placement="bottom" title={langdata && langdata.ViewChainage ? langdata.ViewChainage : 'view chainage'}>
										<Space>
											<Button type="primary" onClick={() => {navigate(( '/chainage-listing'),{ state: { region:null,start:null,end:null,path: 'geofence-management' } });}} style={{margin:'5px'}} ><EyeOutlined/>{langdata && langdata.ViewChainage ? langdata.ViewChainage :'View Chainage' }</Button> 
										</Space>
									</Tooltip>
									<Space>&nbsp;&nbsp;</Space>
									<Space>
										<Typography>
											<Popover title={langdata && langdata.GeofenceManagement ? langdata.GeofenceManagement:'GeoFence  Management'}  content={infoContent} trigger="click">
												<Avatar size="small"><InfoOutlined /></Avatar>
											</Popover>
										</Typography>
									</Space>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>
							{ data && data.geofencemanagement.length > 0 ? (
								<Table
									scroll={{
										x: 900,
									}} 
									columns={columns} 
									dataSource={data && data.geofencemanagement} 
									onRow = {(record) => {
										return {
											onClick: () => { 
												loadGeofenceManagementDetails(record);
											}
										};
									}} />
							)
								:
								(
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								)}
						</Col>
					</Row>
				</Content>

				<Spin fullscreen spinning={data.pending} />
      
				{/* Add Geofencemanagement  Starts */}
				<Modal
					title={ langdata && langdata.AddGeofenceManagement ? langdata.AddGeofenceManagement:'Add Geofence Management' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showAddGeofenceManagementModal}
					onOk={{cloaseAddGeofenceManagementModal}}
					onCancel={cloaseAddGeofenceManagementModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={cloaseAddGeofenceManagementModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addGeofenceManagementFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addGeofenceManagementFormik.handleSubmit}>
						
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} >
									<Input name="addGeofencemanagementName" onChange={addGeofenceManagementFormik.handleChange} placeholder={ langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="limit" label={ langdata && langdata.FenceLimits ? langdata.FenceLimits : 'Fence Limits'} rules={[{ required: true, message: langdata && langdata.PleaseEnterFenceLimits ? langdata.PleaseEnterFenceLimits : 'Please enter Fence Limits' }]} >
									<InputNumber 
										style={{
											width: '100%',
										}}
										name="addGeofencemanagementLimit" 
										onChange={(value) => addGeofenceManagementFormik.setFieldValue('addGeofencemanagementLimit', value)} 
										placeholder={langdata && langdata.PleaseEnterFenceLimits ? langdata.PleaseEnterFenceLimits : 'Please enter fence limits'} 
										min={0}
										max={1000} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="avgVelocity" label={ langdata && langdata.AvgVelocity ? langdata.AvgVelocity : 'Avg Velocity'} rules={[{ required: true, message: langdata && langdata.PleaseEnterAverageVelocity ? langdata.PleaseEnterAverageVelocity : 'Please enter average velocity' }]} >
									<InputNumber 
										style={{
											width: '100%',
										}}
										name="avgVelocity" 
										onChange={(value) => addGeofenceManagementFormik.setFieldValue('averageSpeed', value)} 
										placeholder={langdata && langdata.PleaseEnterAverageVelocity ? langdata.PleaseEnterAverageVelocity : 'Please Enter Average Velocity'} 
										min={0}
										max={1000} />
								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="startTime" label={langdata && langdata.StartTime ? langdata.StartTime : 'Start Time'} rules={[{ required: true, message: langdata && langdata.StartTime ? langdata.StartTime :'Start Time' }]} >
									<TimePicker placeholder={langdata && langdata.StartTime ? langdata.StartTime :'Start Time'} allowClear format={settingstimeformat}  style={{ width: '100%' }} onChange={(value) => addGeofenceManagementFormik.setFieldValue('startTime', value)}/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="endTime" label={langdata && langdata.EndTime ? langdata.EndTime : 'End Time'} rules={[{ required: true, message: langdata && langdata.EndTime ? langdata.EndTime : 'End Time' }]} >
									<TimePicker placeholder={langdata && langdata.EndTime ? langdata.EndTime : 'End Time'} allowClear format={settingstimeformat}  style={{ width: '100%' }} onChange={(value) => addGeofenceManagementFormik.setFieldValue('endTime', value)}/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="notification" label={langdata && langdata.Notifications ? langdata.Notifications : 'Notifications'} rules={[{ required: true, message: langdata && langdata.PleaseEnterNotification ? langdata.PleaseEnterNotification : 'Please enter the  notfication' }]} >
									<Switch checkedChildren= {langdata && langdata.Enabled ? langdata.Enabled : 'Enabled'}  unCheckedChildren= {langdata && langdata.Disabled ? langdata.Disabled : 'Disabled'} defaultunChecked  onChange={(value) => addGeofenceManagementFormik.setFieldValue('addGeofencemanagementNotifications', value)} placeholder={langdata && langdata.PleaseEnterNotification ? langdata.PleaseEnterNotification : 'Please enter the notfication'} />
								</Form.Item>
							</Col>
						</Row>

						
					</Form>
				</Modal>
				{/* Add Geofence Management Ends */}

				{/* Edit Geofence Management Starts */}
				<Modal
				
					title={ langdata && langdata.EditGeofenceManagement ? langdata.EditGeofenceManagement:'Edit Geofence Management'}
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showEditGeofenceManagementModal}
					onOk={{closeEditGeofenceManagementModal}}
					onCancel={closeEditGeofenceManagementModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={closeEditGeofenceManagementModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={updateGeofenceManagementFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={updateGeofenceManagementFormik.handleSubmit}>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={ langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
									<Input name="updateGeofencemanagementName" onChange={updateGeofenceManagementFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} value={updateGeofenceManagementFormik.values.updateGeofencemanagementName} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="limit" label={ langdata && langdata.FenceLimits ? langdata.FenceLimits : 'Fence Limits'} rules={[{ required: true, message: langdata && langdata.PleaseEnterFenceLimits ? langdata.PleaseEnterFenceLimits : 'Please enter Fence Limits' }]} >
									<InputNumber 
										style={{
											width: '100%',
										}}
										name="updateGeofencemanagementLimit" 
										onChange={(value) => updateGeofenceManagementFormik.setFieldValue('updateGeofencemanagementLimit', value)} 
										placeholder={langdata && langdata.PleaseEnterFenceLimits ? langdata.PleaseEnterFenceLimits : 'Please enter fence limits'} 
										min={0}
										max={1000}
										defaultValue ={data.details &&  data.details.limit}  
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="avgVelocity" label={ langdata && langdata.AvgVelocity ? langdata.AvgVelocity : 'Avg Velocity'} rules={[{ required: true, message: langdata && langdata.PleaseEnterAverageVelocity ? langdata.PleaseEnterAverageVelocity : 'Please Enter Average Velocity' }]} >
									<InputNumber 
										style={{
											width: '100%',
										}}
										name="avgVelocity" 
										onChange={(value) => updateGeofenceManagementFormik.setFieldValue('updateAverageSpeed', value)} 
										placeholder={langdata && langdata.PleaseEnterAverageVelocity ? langdata.PleaseEnterAverageVelocity : 'Please Enter Average Velocity'} 
										min={0}
										max={1000}
										defaultValue ={data.details &&  data.details.averageSpeed}  
									/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="startTime" label={langdata && langdata.StartTime ? langdata.StartTime : 'Start Time'} rules={[{ required: true, message: langdata && langdata.StartTime ? langdata.StartTime :'Start Time' }]} >
									<TimePicker placeholder={langdata && langdata.StartTime ? langdata.StartTime :'Start Time'} allowClear format={settingstimeformat}  style={{ width: '100%' }} onChange={(value) => updateGeofenceManagementFormik.setFieldValue('updateStartTime', value)} 
										defaultValue={updateGeofenceManagementFormik.values.updateStartTime ? dayjs(new Date(updateGeofenceManagementFormik.values.updateStartTime)):null} />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="endTime" label={langdata && langdata.EndTime ? langdata.EndTime : 'End Time'} rules={[{ required: true, message: langdata && langdata.EndTime ? langdata.EndTime : 'End Time' }]} >
									<TimePicker placeholder={langdata && langdata.EndTime ? langdata.EndTime : 'End Time'} allowClear format={settingstimeformat}  style={{ width: '100%' }} onChange={(value) => updateGeofenceManagementFormik.setFieldValue('updateEndTime', value)} 
										defaultValue={updateGeofenceManagementFormik.values.updateEndTime ? dayjs(new Date(updateGeofenceManagementFormik.values.updateEndTime)):null} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="notification" label={langdata && langdata.Notifications ? langdata.Notifications : 'Notification'} rules={[{ required: true, message: langdata && langdata.PleaseEnterNotification ? langdata.PleaseEnterNotification : 'Please enter the  notfication' }]} >
									<Switch checkedChildren={langdata && langdata.Enabled ? langdata.Enabled : 'Enabled'}  unCheckedChildren= {langdata && langdata.Disabled ? langdata.Disabled : 'Disabled'}
										checked = {updateGeofenceManagementFormik.values.updateGeofencemanagementNotification} 
										onChange={(value) => updateGeofenceManagementFormik.setFieldValue('updateGeofencemanagementNotification', value)} 
										placeholder={langdata && langdata.PleaseEnterNotification ? langdata.PleaseEnterNotification : 'Please enter the notfication'} />
								</Form.Item>
							</Col>
						</Row>

						
					</Form>
				</Modal>
				{/* EditGeofence Management Ends */}

				{/* Delete Geofence Management Starts */}
				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteGeofenceManagementModal} onOk={deleteGeofenceManagement} onCancel={closeDeleteGeofenceManagementModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.ConfirmDeleteGeofenceManagement ? langdata.ConfirmDeleteGeofenceManagement : 'Are you sure you want to delete this Geofence Management?' }</Col>
					</Row>
				</Modal>
				{/* Delete Geofence Management Ends */}
			</> : null
	);
}